import { useEffect, useRef } from "preact/hooks";
import type { TranscriptLine } from "../transcript";

/** Scrolls with new lines only while the reader is near the bottom (doesn't yank them back while reading history). */
export function Transcript({ lines, name, thinking }: { lines: TranscriptLine[]; name: string; thinking: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  const stick = useRef(true);
  const onScroll = () => {
    const el = ref.current;
    if (el) stick.current = el.scrollHeight - el.scrollTop - el.clientHeight < 40;
  };
  useEffect(() => {
    const el = ref.current;
    if (el && stick.current) el.scrollTop = el.scrollHeight;
  }, [lines, thinking]);
  return (
    <div class="wk-transcript" ref={ref} onScroll={onScroll} aria-live="polite">
      {lines.length === 0 && !thinking && <p class="wk-empty">Your conversation will appear here.</p>}
      {lines.map((l) => (
        <div key={l.id} class={`wk-msg ${l.role}`}>
          <small>{l.role === "user" ? "You" : name}</small>
          {l.text}
        </div>
      ))}
      {thinking && (
        <div class="wk-msg persona wk-typing" aria-label={`${name} is thinking`}><span /><span /><span /></div>
      )}
    </div>
  );
}
